<button class="btn-ghost export-file" [disabled]="disabled">
  <app-icon name="download" [size]="15" [strokeWidth]="2"></app-icon>
  <span>{{label}}</span>
  <i *ngIf="isLoading" class="fa-spin fas fa-spinner"></i>
</button>
